import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'compile',
    property: 'data-compile',
    targetSelector: 'self',
    visible: 'field-hide-all',
    default_value: 'false',
  },
  {
    refreshType: 'all',
    name: 'widget',
    type: 'html:attr',
    targetSelector: '.module',
    property: 'data-widget',
    options: [
      {
        key: 'reviews',
        value: 'Reviews',
      },
      {
        key: 'badge',
        value: 'Star Badge',
      },
      {
        key: 'testimonials',
        value: 'Testimonials',
      },
      {
        key: 'allReviewsPage',
        value: 'All Reviews Page',
      },
    ],
    default_value: 'reviews',
    links: 'ratingsLimit',
  },
  {
    type: 'html:attr',
    name: 'ratingsLimit',
    refreshType: 'all',
    targetSelector: '.module',
    property: 'data-limit',
    default_value: '10',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Hero Banner Atom Module
 */
export class GpRivyoProductReviews extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Rivyo Product Reviews';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'rivyo-product-reviews';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }

  /**
   * check
   * @returns true: change setting after drag
   */
  isAutoRenderSetting() {
    return true;
  }
}
